import { render, staticRenderFns } from "./CustomerStatementDisplayDialog.vue?vue&type=template&id=fb314a0a"
import script from "./CustomerStatementDisplayDialog.vue?vue&type=script&lang=js"
export * from "./CustomerStatementDisplayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports